// Angular
// tslint:disable-next-line:whitespace

import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
// Models
import { Attachment } from './../../models/attachment';
// External
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase } from 'angularfire2/database';
import { FirebaseApp } from 'angularfire2';
import * as moment from 'moment';
import * as lodash from 'lodash';
import { OAuthService } from './../../services/o-auth';
import { ActivatedRoute } from '@angular/router';

import { ApiService } from './../../services/api';

@Component({
    templateUrl: './add.league.component.html'
})
export class AddLeagueComponent implements OnInit {
    public league: any
    private attachment: Attachment;
    private attachmentExt: string;
    private orginalAttachment: Attachment;
    public imageLoader = false
    public selectedTournaments: Array<any>
    constructor(private router: Router, private firebase: FirebaseApp, private apiService: ApiService, private route: ActivatedRoute,
        private fireAuth: AngularFireAuth, private fireDatabase: AngularFireDatabase, private oAuthService: OAuthService) {
        this.league = {
            name: "",
            image: "",
            description: "",
            status: 1
        }
    }
    ngOnInit() {



    }

    changeAttachment(attachment: Attachment): void {
        if (attachment) {
            if (attachment.isOriginal) {
                this.orginalAttachment = attachment
            } else {
                this.attachment = attachment;

            }
            this.attachmentExt = attachment.file.name.split('.').pop();


        } else {
            this.attachmentExt = '';
        }
    }
    private uploadFile(): Promise<any> {
        var newImage = new Promise((resolve, reject) => {
            if (this.attachment) {
                const filename = `${moment().unix()}.${this.attachmentExt}`;
                this.firebase.storage().ref(`/leagues/${this.fireAuth.auth.currentUser.uid}`).child(filename)
                    .put(this.attachment.file)
                    .then(result => resolve(result))
                    .catch(error => reject(error));
            } else {
                return resolve();
            }
        });
        // var OriginalImage = new Promise((resolve, reject) => {
        //     if (this.attachment) {
        //         const filename = `${moment().unix()}.${Math.floor(Math.random() * (900) + 100)}.${this.attachmentExt}`;
        //         this.firebase.storage().ref(`/leagues/${this.fireAuth.auth.currentUser.uid}`).child(filename)
        //             .put(this.orginalAttachment.file)
        //             .then(result => resolve(result))
        //             .catch(error => reject(error));
        //     } else {
        //         return resolve();
        //     }
        // });
        return Promise.all([newImage])
    }
    changeClub(club: any) {
        console.log(club)
        this.selectedTournaments = club
    }

    public addLeague() {
        this.imageLoader = true
        this.league.createdAt = new Date().getTime() / 1000
        this.uploadFile()
            .then(fileResult => {

                if (fileResult[0] && fileResult[0].downloadURL) {
                    this.league.image = fileResult[0].downloadURL
                }
                // if (fileResult[1] && fileResult[1].downloadURL) {
                //     this.league.originalImage = fileResult[1].downloadURL
                // }
                this.league.tournaments = {}
                for (let i = 0; i < this.selectedTournaments.length; i++) {
                    const element = this.selectedTournaments[i];
                    this.league.tournaments[element.$key] = element.eventName
                }

                this.apiService.push("leagues/", this.league).then((res) => {
                    this.imageLoader = false
                    return this.router.navigate(['/components/leagues']);
                })
            })

    }

}



